<template>
  <div
    v-b-popover.hover.left.html="getSpanHover(dataRemark.item.remarks , 'Add Remark')"
    class="hover-pointer"
    @click="addRemark(dataRemark.item.id)"
  >
    {{ getSmallName(dataRemark.item.remarks) }}
  </div>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  name: 'AddRemark',
  props: {
    dataRemark: {
      type: Object,
      required: false,
      default: null,
    },
    getAllDataPass: {
      type: Function,
      required: true,
    },
  },
  methods: {
    addRemark(id) {
      this.$swal.fire({
        title: 'Add Remark',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: async inputValue => {
          try {
            const githubUrl = `/payslip/${id}/remark`
            const response = await axios.patch(githubUrl, { remarks: inputValue })
            // SweetAlert2 expects something returned here
            return response.data || { success: true }
          } catch (error) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$swal.showValidationMessage(
              `${errorMessage}`,
            )
            // Return false to satisfy consistent-return
            return false
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: 'Added successfully',
            icon: 'success',
          })
          this.getAllDataPass()
        }
      })
    },
    getSmallName(input) {
      if (!input) return ''

      const dateMatch = input.match(/\d{4}-\d{2}-\d{2}/)
      if (dateMatch) {
        return dateMatch[0]
      }

      const words = input.trim().split(/\s+/)
      if (words.length <= 3) {
        return input
      }
      return `${words.slice(0, 3).join(' ')}...`
    },
    getSpanHover(name, action) {
      if (name) {
        return `<div style=" text-align: center; color: black">🔄 change</div>
          <div>${name}</div>`
      }
      return `<div style=" text-align: center; color: black">➕ ${action || ''}</div>`
    },
  },
}
</script>
